import React, { useState, Fragment, useCallback, useEffect } from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import IconButton from "../../components/iconButton";
import PageHead from "../../components/pageHead";
import Tooltip from "../../components/tooltip";
import EditIcon from "../../icons/editIcon";
import AddIcon from "../../icons/addIcon";
import TrashIcon from "../../icons/trashIcon";
import Table from "../../components/table";
import ToggleSwitch from "../../components/toggleSwitch";
import SelectInput from "../../components/selectInput";
import InputWithTooltip from "../../components/InputWithTooltip";
import useMediaQuery from "../../hooks/useMediaQuery";
import TutorialConsumablesImage from "../../assets/images/tutorialConsumables.png";
// import { checkScrollDirection } from "../../utils/menuNav";
import ConsumableCard from "../../components/consumableCard";
import AddConsumableModal from "../../components/addConsumableModal";
import DeleteCarModal from "../../components/deleteModal";
import Pagination from "../../components/pagination";
import MobileNav from "../../components/mobileNav";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { useAuth } from "../../hooks/useAuth";
import { useUpdateMonitorBy } from "../../hooks/updateMonitorBy";
import LoadingButton from "../../components/loadingButton";
import CardSkeleton from "../../components/cardSkeleton";
import NoData from "../../components/noData";
import styles from "./style.module.css";
import stylesTable from "../../components/table/style.module.css";
import formStyles from "../../components/form/style.module.css";
const options = [
  { value: "days", label: "Track Days" },
  { value: "sessions", label: "Sessions" },
  { value: "laps", label: "Miles" },
];

const schema = {
  type: "object",
  required: ["name", "expectedLife"],
  properties: {
    name: {
      title: "Item",
      type: "string",
    },
    expectedLife: {
      title: "Expected Life",
      type: "number",
    },
  },
};

const uiSchema = {
  "ui:classNames": formStyles.formInner_p0,
  "ui:rootFieldId": "add_consumable",
  name: {
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_auto}`,
    "ui:placeholder": "Enter Item",
  },
  expectedLife: {
    "ui:widget": InputWithTooltip,
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_auto} ${formStyles.tooltip_label}`,
    "ui:placeholder": "Enter Expected Life",
    "ui:options": {
      label: false,
      tooltipText: (
        <Fragment>
          Set the expected life in # of track days (or sessions/miles). This
          will vary by item, for example, tires might last{" "}
          <strong>12 track days</strong>, and oil changes every{" "}
          <strong>4-5 track days</strong>. If unsure, ask your mechanic.{" "}
          <strong>Tip:</strong> Be conservative at first—round down to encourage
          earlier checks. Better to check early than late!
        </Fragment>
      ),
      position: ["right"],
      transform: { top: -15, left: 1 },
      type: "number",
    },
  },
  "ui:submitButtonOptions": {
    props: {
      className: formStyles.form_btn,
    },
  },
};

const widgets = {
  expectedLife: InputWithTooltip,
};
const SetUpConsumables = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const { auth } = useAuth();
  const updateMonitorBy = useUpdateMonitorBy();

  const [monitorBy, setMonitorBy] = useState({});
  const axiosPrivate = useAxiosPrivate();
  const [formData, setFormData] = useState({});
  const [mainColumns, setMainColumns] = useState({
    columns: [
      {
        name: "toggle",
        title: "",
        width: 50,
        sorting: false,
        direction: "",
      },
      {
        name: "name",
        title: "Item",
        width: 150,
        sorting: true,
        direction: "",
      },
      {
        name: "track_by",
        title: "Track By",
        width: 150,
        sorting: false,
        direction: "",
      },
      {
        name: "expectedLife",
        title: "Expected Life",
        width: 150,
        sorting: true,
        direction: "",
      },
      {
        name: "action",
        title: "Action",
        width: 150,
        sorting: false,
        direction: "",
      },
    ],
  });

  const [rowData, setRowData] = useState([]);

  const [apiParams] = useState({});
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(1);
  const [limitData] = useState(10);
  const [totalData, setTotalData] = useState(0);
  const [isScrolling] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Consumable");
  const [buttonTitle, setButtonTitle] = useState("Add");
  // const [editID, setEditID] = useState(null);
  const [consumableData, setConsumableData] = useState({});
  const [openDeleteModal, setOpenDeletModal] = useState(false);

  const handleSorting = (name, index) => {
    let prm = apiParams;
    let tempCol = mainColumns.columns;
    if (tempCol[index].direction === "") {
      tempCol.map((column) =>
        column.name === name
          ? (column.direction = "ASC")
          : (column.direction = "")
      );
      prm.sort_by = name;
      prm.order = 1;
      prm.page = 1;
    } else if (tempCol[index].direction === "ASC") {
      tempCol.map((column) =>
        column.name === name
          ? (column.direction = "DSC")
          : (column.direction = "")
      );
      prm.sort_by = name;
      prm.order = -1;
      prm.page = 1;
    } else if (tempCol[index].direction === "DSC") {
      tempCol.map((column) => (column.direction = ""));
      prm.page = 1;
      delete prm.sort_by;
      delete prm.order;
    }
    setMainColumns({ columns: tempCol });
    setSelectedPage(1);
    fetchConsumables(apiParams);
  };

  const handleToggleSwitch = (index, value, id) => {
    let tempRowData = rowData;
    tempRowData[index].status = value ? "active" : "inactive";
    setRowData(tempRowData);
    let status = {
      status: value ? 1 : 0,
    };
    handleUpdateConsumableStatus(id, status);
  };

  const handlePaginate = (value) => {
    let prm = apiParams;
    prm.page = value;
    setSelectedPage(value);
    setLoading(true);
    fetchConsumables(prm);
  };

  const onFormSubmit = (formData) => {
    setFormData(formData);
    handleAddConsumable(formData);
    // if (editID) {
    //   // handleUpdateConsumable(formData);
    // } else {
    //   handleAddConsumable(formData);
    // }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
    setModalTitle("Add New Consumable");
    setButtonTitle("Add");
    setFormData({});
  };

  const handleCloseDialog = (changePage = false) => {
    setOpenDialog(false);
    if (changePage) {
      fetchConsumables(apiParams);
    }
  };

  const handleOpenDeleteModal = (item) => {
    setFormData({});
    setOpenDeletModal(true);
    setConsumableData(item);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeletModal(false);
    setConsumableData({});
  };

  const handleEditConsumable = (item) => {
    // setFormData({
    //   name: item.name,
    //   expectedLife: item.expectedLife,
    // });
    setConsumableData({
      name: item.name,
      expectedLife: item.expectedLife,
      _id: item._id,
    });
    // setEditID(item._id);
    setOpenDialog(true);
    setModalTitle("Edit Consumable");
    setButtonTitle("Save");
  };

  const fetchConsumables = useCallback(async (params) => {
    setLoading(true);
    try {
      let urlParams = "";
      if (params) {
        Object.keys(params).forEach(function (key, index) {
          urlParams += (index === 0 ? "?" : "&") + key + "=" + params[key];
        });
      }
      let url = `consumables${urlParams}`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            setRowData(response.data.consumables);
            setTotalData(response.data.total);
            setLoading(false);
          } else {
            setRowData([]);
            setTotalData(0);
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      setLoading(false);
      // console.error('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddConsumable = useCallback(
    async (data) => {
      setSaveLoading(true);
      try {
        let url = `consumables/add`;
        let options = {
          method: "POST",
          url,
          data,
        };
        await axiosPrivate(options)
          .then((response) => {
            if (response.data.status === 1) {
              setFormData({});
              fetchConsumables(apiParams);
            } else {
              setFormData({});
            }
            setSaveLoading(false);
          })
          .catch((err) => {
            if (err.response) {
              setFormData({});
              setSaveLoading(false);
            }
          });
      } catch (error) {
        setFormData({});
        // console.error('error', error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // const handleUpdateConsumable = useCallback(
  //   async (data) => {
  //     try {
  //       let url = `consumables/${editID}`;
  //       let options = {
  //         method: "PUT",
  //         url,
  //         data,
  //       };
  //       await axiosPrivate(options)
  //         .then((response) => {
  //           if (response.data.status === 1) {
  //             fetchConsumables(apiParams);
  //             setFormData({});
  //             setEditID(null);
  //             setModalTitle("Add New Consumable");
  //             setButtonTitle("Add");
  //           } else {
  //             setFormData({});
  //             setModalTitle("Add New Consumable");
  //             setButtonTitle("Add");
  //             // console.error('err.res', response);
  //           }
  //         })
  //         .catch((err) => {
  //           if (err.response) {
  //             setFormData({});
  //           }
  //         });
  //     } catch (error) {
  //       // console.error('error', error);
  //     }
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [editID]
  // );

  const handleUpdateConsumableStatus = useCallback(
    async (id, data) => {
      try {
        let url = `consumables/status/${id}`;
        let options = {
          method: "PUT",
          url,
          data,
        };
        await axiosPrivate(options)
          .then((response) => {
            if (response.data.status === 1) {
            }
          })
          .catch((err) => {
            if (err.response.data.status === 0) {
              fetchConsumables(apiParams);
            }
          });
      } catch (error) {
        // console.error('error', error);
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleMonitorBy = useCallback(
    async (value) => {
      setMonitorBy(value);
      try {
        let data = {
          monitorBy: value.value,
        };
        let url = `consumables/monitor-by`;
        let options = {
          method: "PUT",
          url,
          data,
        };
        await axiosPrivate(options)
          .then((response) => {
            if (response.data.status === 1) {
              updateMonitorBy(response);
            }
          })
          .catch((err) => {
            // console.log("err", err);
          });
      } catch (error) {
        // console.error('error', error);
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleDeleteConsumable = async () => {
    const response = await axiosPrivate.delete(
      `/consumables/${consumableData._id}`
    );
    if (response.data.status === 1) {
      let prm = apiParams;
      prm.page = 1;
      setSelectedPage(1);
      fetchConsumables(prm);
      handleCloseDeleteModal();
    }
  };

  function generateRows(tempArray) {
    const tempRowArray = [];
    if (tempArray) {
      tempArray.map((item, index) =>
        tempRowArray.push({
          toggle: (
            <div className={stylesTable.table_cell_text}>
              <ToggleSwitch
                checked={item.status === "active" ? true : false}
                index={index}
                extraPrm={item._id}
                onChange={handleToggleSwitch}
              />
            </div>
          ),
          name: <div className={stylesTable.table_cell_text}>{item.name}</div>,
          track_by: (
            <div className={stylesTable.table_cell_text}>{monitorBy.label}</div>
          ),
          expectedLife: (
            <div className={stylesTable.table_cell_text}>
              {item.expectedLife}
            </div>
          ),
          action: (
            <div className={stylesTable.table_action}>
              <button type="button" onClick={() => handleEditConsumable(item)}>
                <EditIcon />
              </button>
              <button type="button" onClick={() => handleOpenDeleteModal(item)}>
                <TrashIcon />
              </button>
            </div>
          ),
        })
      );
    }
    return tempRowArray;
  }

  const handleScroll = (e) => {
    // const scrollDirection = checkScrollDirection(e);
    // setIsScrolling(scrollDirection);
  };

  useEffect(() => {
    fetchConsumables(apiParams);
  }, [fetchConsumables, apiParams]);

  useEffect(() => {
    let filterOpt = options.filter((item) => item.value === auth?.monitorBy);
    let monitorByObj = filterOpt[0];
    setMonitorBy(monitorByObj);
  }, [auth?.monitorBy]);

  return (
    <Fragment>
      <PageHead
        logo={isMobile}
        title={isMobile ? "Consumables" : "Set Up Consumables"}
        tutorialContent={
          <Fragment>
            <p>
              If you take your car to the track, your consumables—such as tires,
              brakes, and fluids—are the main wear items you'll want to monitor
              closely. During your initial setup of DashBook, go to the{" "}
              <strong>Set Up Consumables</strong> page and follow the following
              steps:
            </p>
            <img
              src={TutorialConsumablesImage}
              alt={"Setting Up Your Consumables"}
            />
            <ol>
              <li>
                Choose the unit of measurement:{" "}
                <strong>track days, sessions, or miles</strong>. Most users
                prefer <strong>Track Days</strong> for simplicity. However, if
                you run slicks and prefer to monitor heat cycles, selecting{" "}
                <strong>Sessions</strong> may be more appropriate. Keep in mind
                that choosing <strong>Sessions</strong> means all other
                consumables will also be tracked by the number of sessions.
              </li>
              <li>
                Below, you will see a preset list of the most common Consumable
                items to monitor. You can{" "}
                <strong>
                  Deselect any items that <u>you do not wish</u> to track.
                </strong>{" "}
                You can{" "}
                <strong>
                  Add any additional custom items that you would like to monitor
                </strong>{" "}
                to the list by entering their description in the provided field
                above.
              </li>
              <li>
                <p>
                  Set the <strong>Expected Lifespan</strong> of each item by
                  clicking the Edit icon to the right of each line. representing
                  the number of days (or sessions/laps) you expect it to last
                  before requiring replacement. This will vary by item. For
                  example, tires may last <strong>12 track days</strong>, while
                  oil changes might be needed every{" "}
                  <strong>4-5 track days</strong>. If you're unsure, consult
                  your mechanic.
                </p>
                <p>
                  <strong>Tip:</strong> When first setting expected lifespans,{" "}
                  <strong>be conservative</strong>—round down to encourage
                  earlier inspections. It's always better to check too soon than
                  too late! Additionally, if you're using a new model or brand
                  of consumables, estimate their lifespan conservatively. For
                  example, a new brand or model of tires may not last as long as
                  your previous set.
                </p>
                <p>
                  <strong>Tip:</strong> Expect wear to increase as your pace
                  improves: e.g., a beginner’s tires might last a season, but as
                  you build speed, they may only last a few weekends. beginner’s
                  tires might last a season, but as you build speed, they may
                  only last a few weekends.
                </p>
              </li>
            </ol>
            <p>
              Note: Once you've set up your main consumables, you won’t need to
              revisit this page unless you want to update lifespans or add new
              items. Moving forward, you’ll update consumable statuses from the
              <strong>Add New Service</strong> page.
            </p>
          </Fragment>
        }
      />
      <div className={styles.body}>
        <div className={styles.select_wrapper}>
          <div className={styles.select_wrapper_inner}>
            {!isMobile && (
              <div className={styles.body_title}>
                <span>Monitor By</span>
                <Tooltip
                  content={
                    <Fragment>
                      Choose how you'll monitor usage: by{" "}
                      <strong>Track Days, Sessions, or Miles</strong>. Most
                      prefer <strong>Track Days</strong> for simplicity. Use{" "}
                      <strong>Sessions</strong> if you run slicks and prefer to
                      monitor heat cycles. Note that choosing{" "}
                      <strong>Sessions</strong> means <u>all consumables</u>{" "}
                      will also be tracked per session.
                    </Fragment>
                  }
                  position={["right"]}
                  transform={{ top: 15, left: 5 }}
                  customClass={styles.tooltip_icon}
                />
              </div>
            )}
            <SelectInput
              options={{
                options: options,
              }}
              value={JSON.stringify(monitorBy)}
              isFormField={false}
              placeholder="Select Item"
              onChange={handleMonitorBy}
            />
          </div>
          {isMobile && (
            <IconButton
              customClass={styles.add_icon}
              icon={<AddIcon />}
              onClick={handleOpenDialog}
            />
          )}
        </div>
        {!isMobile && (
          <Fragment>
            <div className={styles.add_form}>
              <Form
                className={`${formStyles.form} ${formStyles.form_inline}`}
                schema={schema}
                uiSchema={uiSchema}
                formData={formData}
                validator={validator}
                widgets={widgets}
                showErrorList={false}
                omitExtraData={true}
                liveValidate={false}
                onSubmit={({ formData }) => {
                  onFormSubmit(formData);
                }}
              >
                <div className={styles.form_actions}>
                  <LoadingButton
                    type="submit"
                    loading={saveLoading}
                    title={"Add"}
                  />
                </div>
              </Form>
            </div>
            <div className={styles.body_title}>
              Select which Items to track below
            </div>
          </Fragment>
        )}
        <div className={styles.body_view} onScroll={handleScroll}>
          {isMobile ? (
            <Fragment>
              {rowData.map((item, index) => (
                <ConsumableCard
                  key={index}
                  item={item}
                  index={index}
                  track_by={monitorBy.label}
                  handleToggleSwitch={handleToggleSwitch}
                  handleEdit={handleEditConsumable}
                  handleDelete={handleOpenDeleteModal}
                />
              ))}
              {loading && <CardSkeleton />}
              {totalData === 0 && !loading && <NoData />}
            </Fragment>
          ) : (
            <Table
              rows={generateRows(rowData)}
              columns={mainColumns.columns}
              selectedPage={selectedPage}
              handlePagination={handlePaginate}
              loading={loading}
              handleSort={handleSorting}
              limitData={limitData}
              totalData={totalData}
            />
          )}
        </div>
        {isMobile && (
          <Fragment>
            {totalData > limitData && (
              <div className={styles.body_foot}>
                <Pagination
                  totalPages={totalData}
                  limitData={limitData}
                  selectedPage={selectedPage}
                  handlePagination={handlePaginate}
                />
              </div>
            )}
          </Fragment>
        )}
      </div>
      <AddConsumableModal
        consumableData={consumableData}
        title={modalTitle}
        buttonTitle={buttonTitle}
        open={openDialog}
        onClose={handleCloseDialog}
      />
      {isMobile && (
        <Fragment>
          <MobileNav defaultActive={true} isScrolling={isScrolling} />
        </Fragment>
      )}
      <DeleteCarModal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        title="Deleting Consumable"
        description="Are you sure you want to delete this record? This process cannot be undone."
        onDelete={handleDeleteConsumable}
      />
    </Fragment>
  );
};

export default SetUpConsumables;
